import { VisualSuper } from "./visual-super.component.js";

class Text extends VisualSuper {
  namespace = "visual:text";
}

const text = new Text();
export { Text, text };
